import React from 'react'
import NoPadH3 from '../../titles/NoPadH3'
import Divider from '../../Divider'
import { Form, Button } from 'react-bootstrap'

const GoalCreator = () => {
  return (<>
    <NoPadH3>Goal Creator</NoPadH3>
    <Divider />
    <Form  className='pt-4 w-100 m-auto'>

      <Form.Group className="mb-3" controlId="formName">
        <Form.Label> Name</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' required type="name" placeholder="Enter Name" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formDescription">
        <Form.Label>Description</Form.Label>
        <Form.Control className='py-2 px-3 fs-5'  required type="description" placeholder="Enter Description" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formEmail">
        <Form.Label>Deadline</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' required type="date" />

      </Form.Group>
      <Button  className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
        Submit
      </Button>
    </Form>
  </>)
}

export default GoalCreator